import { Component, Input, ViewChild } from '@angular/core'
import { AddressComponent } from '@exchange/ui/shared/controls/address/address.component'
import { IProvider, ProviderODataService, ProviderStateODataService } from '@exchange/app/domain'
import { UtilService, SessionService } from '@exchange/app/services'
import { Observable } from 'rxjs'
import { AppSelectComponent } from 'common-components'
import { Option } from 'common-components'

@Component({
  selector: 'app-providers-edit-edi-config',
  templateUrl: './providers-edit-edi-config.component.html',
  standalone: false
})
export class ProvidersEditEdiConfigComponent {
  private _model: IProvider = {} as IProvider
  states: Option[] = []
  public ISAValues: string[] = ['01', '14', '20', '27', '28', '29', '30', '33', 'ZZ']

  get model(): IProvider {
    return this._model
  }
  private createdBy: string
  private createdOn: Date = new Date()

  @ViewChild('payeeStateList') payeeStateList: AppSelectComponent
  @ViewChild('payerStateList') payerStateList: AppSelectComponent
  @ViewChild('mailingAddress') mailingAddress: AddressComponent

  @Input()
  set model(m: IProvider) {
    this._model = m
    this._model = m
    this.initializeStates()
    this.session.getCurrentUser().subscribe(user => {
      this.createdBy = user.Id
    })

    if (!this._model.BankingConfiguration) {
      this._model.BankingConfiguration = {
        CreatedByIdentity: this.createdBy,
        CreatedOnDateTime: this.createdOn,
        LastModifiedByIdentity: null,
        LastModifiedOnDateTime: null,
        BPR06PayerRoutingNumberQualifier: '01',
        BPR07PayerRoutingNumber: null,
        BPR08PayerAccountNumberQualifier: 'DA',
        BPR10PayerIdentifier: null,
        BPR12PayeeRoutingNumberQualifier: '01',
        BPR09PayerAccountNumber: null,
        BPR14PayeeAccountNumberQualifier: 'DA',
        BPR13PayeeRoutingNumber: null,
        BPR15PayeeAccountNumber: null
      }
    }

    if (!this._model.InterchangeConfiguration) {
      this._model.InterchangeConfiguration = {
        CreatedByIdentity: this.createdBy,
        CreatedOnDateTime: this.createdOn,
        LastModifiedByIdentity: null,
        LastModifiedOnDateTime: null,
        ISA05SenderIdQualifier: null,
        ISA06SenderId: null,
        ISA07ReceiverIdQualifier: null,
        ISA08ReceiverId: null
      }
    }

    if (!this._model.PayeeAddressConfiguration) {
      this._model.PayeeAddressConfiguration = {
        CreatedByIdentity: this.createdBy,
        CreatedOnDateTime: this.createdOn,
        LastModifiedByIdentity: null,
        LastModifiedOnDateTime: null,
        AddressLine1: this.model.MailingAddress ? this.model.MailingAddress.Address1 : null,
        AddressLine2: this.model.MailingAddress ? this.model.MailingAddress.Address2 : null,
        CityName: this.model.MailingAddress ? this.model.MailingAddress.CityName : null,
        StateCode: null,
        StateId: this.model.MailingAddress ? this.model.MailingAddress.StateId : null,
        PostalCode: this.model.MailingAddress ? this.model.MailingAddress.ZipCode : null
      }
    }

    if (!this._model.PayerAddressConfiguration) {
      this._model.PayerAddressConfiguration = {
        CreatedByIdentity: this.createdBy,
        CreatedOnDateTime: this.createdOn,
        LastModifiedByIdentity: null,
        LastModifiedOnDateTime: null,
        AddressLine1: null,
        AddressLine2: null,
        CityName: null,
        StateCode: null,
        StateId: null,
        PostalCode: null
      }
    }

    if (!this._model.PayeeAdditionalInformationConfiguration) {
      this._model.PayeeAdditionalInformationConfiguration = {
        CreatedByIdentity: this.createdBy,
        CreatedOnDateTime: this.createdOn,
        LastModifiedByIdentity: null,
        LastModifiedOnDateTime: null,
        ReferenceIdentificationQualifier: 'TJ',
        ReferenceIdentification: this.model ? this.model.TaxIdNumber : null
      }
    }

    if (!this._model.PayerAdditionalInformationConfiguration) {
      this._model.PayerAdditionalInformationConfiguration = {
        CreatedByIdentity: this.createdBy,
        CreatedOnDateTime: this.createdOn,
        LastModifiedByIdentity: null,
        LastModifiedOnDateTime: null,
        ReferenceIdentificationQualifier: null,
        ReferenceIdentification: null
      }
    }

    if (!this._model.PayeeIdentificationConfiguration) {
      this._model.PayeeIdentificationConfiguration = {
        CreatedByIdentity: this.createdBy,
        CreatedOnDateTime: this.createdOn,
        LastModifiedByIdentity: null,
        LastModifiedOnDateTime: null,
        Name: this.model ? this.model.Name : null,
        IdentificationCode: this.model ? this.model.Npi : null,
        IdentificationCodeQualifier: 'XX'
      }
    }

    if (!this._model.PayerIdentificationConfiguration) {
      this._model.PayerIdentificationConfiguration = {
        CreatedByIdentity: this.createdBy,
        CreatedOnDateTime: this.createdOn,
        LastModifiedByIdentity: null,
        LastModifiedOnDateTime: null,
        Name: null,
        IdentificationCode: null,
        IdentificationCodeQualifier: null
      }
    }

    if (!this._model.PayerTechnicalContactInformationConfiguration) {
      this._model.PayerTechnicalContactInformationConfiguration = {
        CreatedByIdentity: this.createdBy,
        CreatedOnDateTime: this.createdOn,
        LastModifiedByIdentity: null,
        LastModifiedOnDateTime: null,
        Name: 'Contessa Claims Processing',
        CommunicationNumberQualifier: 'TE',
        CommunicationNumber: null,
        CommunicationNumberExtension: null
      }
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false
    }
    return true
  }

  constructor(
    private odata: ProviderODataService,
    public util: UtilService,
    private providerStateService: ProviderStateODataService,
    private session: SessionService
  ) { }

  public clearPayerAddressConfig(): void {
    this.model.PayerAddressConfiguration.AddressLine1 = null
    this.model.PayerAddressConfiguration.AddressLine2 = null
    this.model.PayerAddressConfiguration.CityName = null
    this.model.PayerAddressConfiguration.StateId = null
    this.model.PayerAddressConfiguration.StateCode = null
    this.model.PayerAddressConfiguration.PostalCode = null
    this.payerStateList.active = null
  }

  public clearBankingConfig(): void {
    this.model.BankingConfiguration.BPR06PayerRoutingNumberQualifier = null
    this.model.BankingConfiguration.BPR07PayerRoutingNumber = null
    this.model.BankingConfiguration.BPR08PayerAccountNumberQualifier = null
    this.model.BankingConfiguration.BPR10PayerIdentifier = null
    this.model.BankingConfiguration.BPR12PayeeRoutingNumberQualifier = null
    this.model.BankingConfiguration.BPR09PayerAccountNumber = null
    this.model.BankingConfiguration.BPR14PayeeAccountNumberQualifier = null
    this.model.BankingConfiguration.BPR13PayeeRoutingNumber = null
    this.model.BankingConfiguration.BPR15PayeeAccountNumber = null
  }

  public clearInterchangeConfig(): void {
    this.model.InterchangeConfiguration.ISA05SenderIdQualifier = null
    this.model.InterchangeConfiguration.ISA06SenderId = null
    this.model.InterchangeConfiguration.ISA07ReceiverIdQualifier = null
    this.model.InterchangeConfiguration.ISA08ReceiverId = null
  }

  public clearPayerAdditionalInfoConfig(): void {
    this.model.PayerAdditionalInformationConfiguration.ReferenceIdentificationQualifier = null
    this.model.PayerAdditionalInformationConfiguration.ReferenceIdentification = null
  }

  public clearPayerIdentificationConfig(): void {
    this.model.PayerIdentificationConfiguration.Name = null
    this.model.PayerIdentificationConfiguration.IdentificationCode = null
    this.model.PayerIdentificationConfiguration.IdentificationCodeQualifier = null
  }

  public clearPayerTechnicalContactInformationConfig(): void {
    this.model.PayerTechnicalContactInformationConfiguration.Name = null
    this.model.PayerTechnicalContactInformationConfiguration.CommunicationNumber = null
    this.model.PayerTechnicalContactInformationConfiguration.CommunicationNumberExtension = null
  }

  initializeStates(): void {
    this.providerStateService
      .query()
      .orderBy('Abbreviation')
      .exec()
      .subscribe(response => {
        this.states = response.data.map(x => new Option(x.Id, `${x.Abbreviation} - (${x.Name})`, x))

        if (this.model && this.model.MailingAddress && !this.hasPayeeAddressData()) {
          this.model.PayeeAddressConfiguration.AddressLine1 = this.model.MailingAddress.Address1
          this.model.PayeeAddressConfiguration.AddressLine2 = this.model.MailingAddress.Address2
          this.model.PayeeAddressConfiguration.CityName = this.model.MailingAddress.CityName
          this.model.PayeeAddressConfiguration.StateId = this.model.MailingAddress.StateId
          this.model.PayeeAddressConfiguration.PostalCode = this.model.MailingAddress.ZipCode
        }

        if (this.model && this.model.PayeeAddressConfiguration.StateId) {
          this.payeeStateList.active = [
            this.states.find(x => x.id === this.model.PayeeAddressConfiguration.StateId)
          ]
        }

        if (this.model && this.model.PayerAddressConfiguration.StateId) {
          this.payerStateList.active = [
            this.states.find(x => x.id === this.model.PayerAddressConfiguration.StateId)
          ]
        }
      })
  }

  selectedPayeeState = (e: any = null) => {
    this.model.PayeeAddressConfiguration.StateId = (e && e.id) || null
    this.model.PayeeAddressConfiguration.StateCode = (e && e.text.substr(0, 2)) || null
  }

  selectedPayerState = (e: any = null) => {
    this.model.PayerAddressConfiguration.StateId = (e && e.id) || null
    this.model.PayerAddressConfiguration.StateCode = (e && e.text.substr(0, 2)) || null
  }

  validate(): string[] {
    const errors: string[] = []

    if (this.hasPayeeAddressData()) {
      if (!this.model.PayeeAddressConfiguration.AddressLine1) {
        errors.push(`Payee Address 1 is required.`)
      }
      if (!this.model.PayeeAddressConfiguration.CityName) {
        errors.push(`Payee City is required.`)
      }
      if (!this.model.PayeeAddressConfiguration.StateId) {
        errors.push(`Payee State is required.`)
      }
      if (!this.model.PayeeAddressConfiguration.PostalCode) {
        errors.push(`Payee Zip Code is required.`)
      }
    }

    if (this.hasPayerAddressData()) {
      if (!this.model.PayerAddressConfiguration.AddressLine1) {
        errors.push(`Payer Address 1 is required.`)
      }
      if (!this.model.PayerAddressConfiguration.CityName) {
        errors.push(`Payer City is required.`)
      }
      if (!this.model.PayerAddressConfiguration.StateId) {
        errors.push(`Payer State is required.`)
      }
      if (!this.model.PayerAddressConfiguration.PostalCode) {
        errors.push(`Payer Zip Code is required.`)
      }
    }

    if (this.hasBankingConfigurationData()) {
      if (!this.model.BankingConfiguration.BPR07PayerRoutingNumber) {
        errors.push(`BPR07 Payer Routing Number is required.`)
      }
      if (
        this.model.BankingConfiguration.BPR07PayerRoutingNumber &&
        this.model.BankingConfiguration.BPR07PayerRoutingNumber.length > 12
      ) {
        errors.push(`BPR07 Payer Routing Number cannot exceed 12 characters.`)
      }
      if (!this.model.BankingConfiguration.BPR10PayerIdentifier) {
        errors.push(`BPR10 Payer Identifier is required.`)
      }
      if (!this.model.BankingConfiguration.BPR12PayeeRoutingNumberQualifier) {
        errors.push(`BPR12 Payee Routing Number Qualifier is required.`)
      }
      if (!this.model.BankingConfiguration.BPR09PayerAccountNumber) {
        errors.push(`BPR09 Payer Account Number is required.`)
      }
      if (!this.model.BankingConfiguration.BPR13PayeeRoutingNumber) {
        errors.push(`BPR13 Payee Routing Number is required.`)
      }
      if (!this.model.BankingConfiguration.BPR15PayeeAccountNumber) {
        errors.push(`BPR15 Payee Account Number is required.`)
      }
    }

    if (this.hasInterchangeConfigurationData()) {
      if (!this.model.InterchangeConfiguration.ISA06SenderId) {
        errors.push(`ISA06 Sender Id is required.`)
      }
      if (!this.model.InterchangeConfiguration.ISA08ReceiverId) {
        errors.push(`ISA08 Receiver Id is required.`)
      }
      if (
        this.model.InterchangeConfiguration.ISA06SenderId &&
        this.model.InterchangeConfiguration.ISA06SenderId.length > 15
      ) {
        errors.push(`ISA06 Sender Id cannot exceed 15 characters.`)
      }
      if (
        this.model.InterchangeConfiguration.ISA08ReceiverId &&
        this.model.InterchangeConfiguration.ISA08ReceiverId.length > 15
      ) {
        errors.push(`ISA08 Receiver cannot exceed 15 characters.`)
      }
    }

    if (this.hasPayeeAdditionalInformationConfigData()) {
      if (!this.model.PayeeAdditionalInformationConfiguration.ReferenceIdentificationQualifier) {
        errors.push(`Reference Identification Qualifier is required.`)
      }
      if (!this.model.PayeeAdditionalInformationConfiguration.ReferenceIdentification) {
        errors.push(`Reference Identification is required.`)
      }
    }

    if (this.hasPayerAdditionalInformationConfigData()) {
      if (!this.model.PayerAdditionalInformationConfiguration.ReferenceIdentificationQualifier) {
        errors.push(`Reference Identification Qualifier is required.`)
      }
      if (!this.model.PayerAdditionalInformationConfiguration.ReferenceIdentification) {
        errors.push(`Reference Identification is required.`)
      }
    }

    if (this.hasPayeeIdentificationConfigData()) {
      if (!this.model.PayeeIdentificationConfiguration.Name) {
        errors.push(`Name is required.`)
      }
      if (!this.model.PayeeIdentificationConfiguration.IdentificationCode) {
        errors.push(`Identification Code is required.`)
      }
      if (!this.model.PayeeIdentificationConfiguration.IdentificationCodeQualifier) {
        errors.push(`Identification Code Qualifier is required.`)
      }
    }

    if (this.hasPayerTechnicalContactInformationConfigData()) {
      if (!this.model.PayerTechnicalContactInformationConfiguration.CommunicationNumber) {
        errors.push(`Communication Number is required.`)
      }
    }
    return errors
  }

  hasPayeeAddressData(): boolean {
    return !!(
      this.model.PayeeAddressConfiguration.AddressLine1 ||
      this.model.PayeeAddressConfiguration.AddressLine2 ||
      this.model.PayeeAddressConfiguration.StateCode ||
      this.model.PayeeAddressConfiguration.StateId ||
      this.model.PayeeAddressConfiguration.CityName ||
      this.model.PayeeAddressConfiguration.PostalCode
    )
  }

  hasPayerAddressData(): boolean {
    return !!(
      this.model.PayerAddressConfiguration.AddressLine1 ||
      this.model.PayerAddressConfiguration.AddressLine2 ||
      this.model.PayerAddressConfiguration.StateId ||
      this.model.PayerAddressConfiguration.StateCode ||
      this.model.PayerAddressConfiguration.CityName ||
      this.model.PayerAddressConfiguration.PostalCode
    )
  }

  hasBankingConfigurationData(): boolean {
    return !!(
      this.model.BankingConfiguration.BPR07PayerRoutingNumber ||
      this.model.BankingConfiguration.BPR10PayerIdentifier ||
      this.model.BankingConfiguration.BPR09PayerAccountNumber ||
      this.model.BankingConfiguration.BPR13PayeeRoutingNumber ||
      this.model.BankingConfiguration.BPR15PayeeAccountNumber
    )
  }

  hasInterchangeConfigurationData(): boolean {
    return !!(
      this.model.InterchangeConfiguration.ISA05SenderIdQualifier ||
      this.model.InterchangeConfiguration.ISA06SenderId ||
      this.model.InterchangeConfiguration.ISA07ReceiverIdQualifier ||
      this.model.InterchangeConfiguration.ISA08ReceiverId
    )
  }

  hasPayeeAdditionalInformationConfigData(): boolean {
    return !!(
      this.model.PayeeAdditionalInformationConfiguration.ReferenceIdentificationQualifier ||
      this.model.PayeeAdditionalInformationConfiguration.ReferenceIdentification
    )
  }

  hasPayerAdditionalInformationConfigData(): boolean {
    return !!(
      this.model.PayerAdditionalInformationConfiguration.ReferenceIdentificationQualifier ||
      this.model.PayerAdditionalInformationConfiguration.ReferenceIdentification
    )
  }

  hasPayeeIdentificationConfigData(): boolean {
    return !!(
      this.model.PayeeIdentificationConfiguration.Name ||
      this.model.PayeeIdentificationConfiguration.IdentificationCode ||
      this.model.PayeeIdentificationConfiguration.IdentificationCodeQualifier
    )
  }

  hasPayerTechnicalContactInformationConfigData(): boolean {
    return !!(
      this.model.PayerTechnicalContactInformationConfiguration.CommunicationNumber ||
      this.model.PayerTechnicalContactInformationConfiguration.CommunicationNumberExtension
    )
  }

  refineInterchangeConfiguration() {
    if (this.model.InterchangeConfiguration.ISA05SenderIdQualifier === '') {
      this.model.InterchangeConfiguration.ISA05SenderIdQualifier = null
    }
    if (this.model.InterchangeConfiguration.ISA07ReceiverIdQualifier === '') {
      this.model.InterchangeConfiguration.ISA07ReceiverIdQualifier = null
    }
  }

  public save(): Observable<IProvider> {
    this.refineInterchangeConfiguration()
    const model = {
      Id: +this.model.Id || undefined,
      BankingConfiguration: this.hasBankingConfigurationData()
        ? this.model.BankingConfiguration
        : null,
      InterchangeConfiguration: this.model.InterchangeConfiguration,
      PayeeAddressConfiguration: this.model.PayeeAddressConfiguration,
      PayerAddressConfiguration: this.model.PayerAddressConfiguration,
      PayeeAdditionalInformationConfiguration: this.model.PayeeAdditionalInformationConfiguration,
      PayerAdditionalInformationConfiguration: this.model.PayerAdditionalInformationConfiguration,
      PayeeIdentificationConfiguration: this.model.PayeeIdentificationConfiguration,
      PayerIdentificationConfiguration: this.model.PayerIdentificationConfiguration,
      PayerTechnicalContactInformationConfiguration: this.hasPayerTechnicalContactInformationConfigData()
        ? this.model.PayerTechnicalContactInformationConfiguration
        : null
    } as IProvider

    return this.odata.customAction(this.model.Id, 'Default.UpdateEdiConfigurations', { dto: model })
  }
}
